// export const BASE_URL_API = "https://cors-anywhere.herokuapp.com/https://fast-track.stylelink.in/apis";
export const BASE_URL_API = "https://fast-track.stylelink.in/apis";